<div class="body-app">
  <div class="login-body">
    <div class="login-logo-app">
      <img src="assets/images/logo-meep.png" alt="logo">
    </div>
    <form>
      <app-input [inputModel]="user.usernameInputModel" (isInputValid)="setFormStatus($event, 'username')" [(value)]="user.username" style="border: 0;"></app-input>
      <app-input [inputModel]="user.passwordInputModel" (isInputValid)="setFormStatus($event, 'password')" [(value)]="user.password"></app-input>
      <a routerLink="/esquecerSenha" class="newAccount newPassword">Esqueci minha senha</a>
      <div class="button-row">
        <button mat-button class="buttonEnter" (click)="signIn()">Entrar</button>
      </div>
    </form>

    <a routerLink="/criarConta" class="newAccount">Primeiro Acesso?</a>

    <div>
      <a *ngIf="showGoogleDownloadStoreLink" class="social-app  margin-alt" href="https://play.google.com/store/apps/details?id=promptus.app.meep"
        target="_blank" title="Google Play">
        <img src="assets/images/google.png" alt="logo">
      </a>

      <a *ngIf="showAppleDownloadStoreLink" class="social-app  margin-alt" href="https://itunes.apple.com/us/app/meep/id1023264775"
        target="_blank" title="Apple Store">
        <img src="assets/images/apple.png" alt="logo">
      </a>
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/login/login.component.html